import {
    campaignPopShotActions,
    campaignPopShotThunks as defaultThunks,
    campaignPopShotSelectors as defaultSelectors,
    campaignPopShotReducer,
} from './CampaignPopShot-slice';
import * as thunks from './CampaignPopShot-thunks';
import * as selectors from './CampaignPopShot-selectors';

const campaignPopShotThunks = { ...defaultThunks, ...thunks };
const campaignPopShotSelectors = { ...defaultSelectors, ...selectors };

export {
    campaignPopShotSelectors,
    campaignPopShotActions,
    campaignPopShotThunks,
    campaignPopShotReducer,
};
